<template>
  <cards :row="true" class="!items-stretch h-full">
    <Card class="w-3/4 h-full">
      <div class="flex flex-col h-full">
        <div class="relative h-full">
          <Image
            alt="Photo"
            :src="photo?.file?.contentUrl"
            :enlargeable="true"
            :rotation-enabled="true"
            :file-entity="photo?.file"
          />
        </div>
      </div>
    </Card>
    <Card class="w-1/4">
      <Readonly class="w-full mb-3" :label="$t('pages.visibility.photo.modal.owner')">
        {{ !!owner ? `${owner.firstName} ${owner.lastName}` : '' }}
      </Readonly>
      <Readonly class="w-full mb-3" :label="$t('pages.visibility.photo.modal.campaign')">
        {{
          props?.photo?.visibilityTransfer?.visibilityPlanning?.campaign?.name
            ? `${props?.photo?.visibilityTransfer?.visibilityPlanning?.campaign?.name}`
            : $t('unknown')
        }}
      </Readonly>
      <Readonly class="w-full mb-3" :label="$t('pages.visibility.photo.modal.coordinates')">
        {{
          props?.photo?.gisLocation
            ? `${props.photo.gisLocation.lat}, ${props.photo.gisLocation.long}`
            : $t('unknown')
        }}
      </Readonly>
      <Readonly class="w-full mb-3" :label="$t('visibility.bicycle')">
        {{
          props?.photo?.visibilityTransfer?.visibilityBicycle?.number
            ? `${props?.photo?.visibilityTransfer?.visibilityBicycle?.number}`
            : $t('unknown')
        }}
      </Readonly>
    </Card>
  </cards>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Cards from '@utils/Cards.vue';
import Card from '@utils/Card.vue';
import Image from '@utils/Image.vue';
import Readonly from '@utils/Readonly.vue';
import type { VisibilityPhoto } from '@/entities/Entities';

interface Props {
  photo: VisibilityPhoto;
  loadingRated: boolean;
}

const props = defineProps<Props>();

const owner = computed(() => props?.photo?.owner);
</script>

<style lang="scss" scoped>
:deep(.card-body) {
  height: 100%;
}

:deep(img) {
  position: absolute;
  object-fit: contain;
  height: 100%;
}

:deep(.custom-readonly .field:focus-within) {
  outline: none;
}
</style>
